import commonPageData from './common.pageData';
import appPageData from './app.pageData';
import otaPageData from './ota.pageData';

export default [...commonPageData, ...appPageData, ...otaPageData];
